var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50085 3.77815L5.19496 0H0L6.61177 8.02858L12.0528 5.7853L8.50085 3.77815Z",
    fill: "#55ACEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8069 0L8.50098 3.77815L11.0465 7.23139L11.626 6.52818L17.0018 0H11.8069Z",
    fill: "#3B88C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9593 7.56479C10.9971 7.46231 11.0212 7.35321 11.0212 7.23751C11.0212 6.71612 10.598 6.29297 10.0766 6.29297H6.92799C6.40614 6.29297 5.98346 6.71612 5.98346 7.23751C5.98346 7.35321 6.00707 7.46231 6.04532 7.56479C4.50667 8.42715 3.46484 10.0711 3.46484 11.9602C3.46437 14.7423 5.71993 16.9979 8.50207 16.9979C11.2842 16.9979 13.5398 14.7423 13.5398 11.9602C13.5398 10.0711 12.4979 8.42715 10.9593 7.56479Z",
    fill: "#CCD6DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3905 13.6589H8.71728C9.13193 13.0761 9.85639 12.1316 10.1388 11.6277C10.3509 11.2125 10.4831 10.9481 10.4831 10.4801C10.4831 9.49962 9.74163 8.69629 8.47879 8.69629C7.42799 8.69629 6.7125 9.56149 6.7125 9.56149C6.65063 9.63233 6.6596 9.73812 6.72147 9.79148L7.26033 10.3388C7.3307 10.4097 7.43696 10.4097 7.50733 10.3388C7.67498 10.1532 8.00179 9.89727 8.36355 9.89727C8.85802 9.89727 9.14091 10.1972 9.14091 10.5329C9.14091 10.7799 9.02615 11.0274 8.91138 11.204C8.39 11.9984 7.08323 13.7737 6.57129 14.4448V14.6214C6.57129 14.7102 6.64166 14.789 6.73894 14.789H10.3905C10.4784 14.789 10.5582 14.7097 10.5582 14.6214V13.827C10.5587 13.7382 10.4784 13.6589 10.3905 13.6589Z",
    fill: "#627077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silver-medal.81c8244277d5c9fd8dececab425b65f2.svg";
export { ForwardRef as ReactComponent };